var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, Modal, ModalBody, Row } from 'reactstrap';
import theme from 'Theme';
import { RenderTicket, TypeAction } from '../../../components/Ticket/Ticket';
import { Range } from '../../DashboardTicket/Util/Mapea';
import { typeList } from '../Store';
import { getData } from './TicketSales';
import { T } from '../../../helpers/i18n';
var TicketRenderModal = /** @class */ (function (_super) {
    __extends(TicketRenderModal, _super);
    function TicketRenderModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hideModalDatePicker: true
        };
        _this.handleRefund = function (ticket) {
            ticket = toTotalesNegativo(ticket);
            // borro las propiedades con key nombre de categoría de pasajero añadido para mostrarlo en la tabla en ventas generales
            for (var _i = 0, _a = ticket.lines; _i < _a.length; _i++) {
                var line = _a[_i];
                delete ticket[line.passengerCategoryName];
            }
            delete ticket.contactAdditional;
            delete ticket.contactEmail;
            delete ticket.contactName;
            delete ticket.contactPhone;
            delete ticket.dateBook;
            delete ticket.dateCheck;
            delete ticket.hasAllocations;
            delete ticket.operatorName;
            delete ticket.packet;
            delete ticket.status;
            delete ticket.stretch;
            delete ticket.time;
            delete ticket.tramoHorario;
            delete ticket.typeSale;
            ticket.totalNet = Number(ticket.totalNet);
            _this.props.store.reports.cancelTicket(ticket, _this.props.store.users.user)
                .then(function (value) {
                if (_this.props.onRefunded) {
                    _this.props.onRefunded(value);
                }
                if (_this.props.onToggle) {
                    _this.props.onToggle();
                }
            })
                .catch(function (error) {
                // alert(error.message)
                console.log('handleRefund - error: ', error);
                _this.props.store.UI.newError('se ha producido un error, intentelo más tarde');
            });
        };
        _this.handleChangeInput = function (method, input) {
            var _value = input.currentTarget.value;
            // console.log('method: ', method)
            // console.log('input: ', _value)
            if (_value === '') {
                return;
            }
            var numero = Number(_value);
            if (Number.isNaN(numero)) {
                return _this.props.store.UI.newWarning('Valor introducido no válido');
            }
            _this.props.store.tempDuePaymentsStore.setPayment(method, numero);
        };
        _this.handleUpdateAdditionalNote = function (ticket) {
            var data = {
                additionalNote: ticket.additionalNote,
                id: ticket.id,
            };
            if (ticket.operatorName) {
                data['numero'] = ticket.numero;
                data['operatorName'] = ticket.operatorName;
            }
            _this.props.store.reports.updateAdditionalNote(data)
                .then(function (result) {
                if (result.code === 200) {
                    _this.props.store.UI.newWarning(result.message);
                    if (_this.props.onChangeAdditionalNote) {
                        _this.props.onChangeAdditionalNote(result);
                    }
                    _this.props.onToggle();
                }
                else {
                    _this.props.store.UI.newError(result.message);
                }
            });
        };
        _this.handleOnclick = function (action, data) {
            if (!action) {
                return;
            }
            switch (action) {
                case TypeAction.ShowPay:
                    break;
                case TypeAction.Refund:
                    _this.handleRefund(data);
                    break;
                case TypeAction.Pay:
                    var isAgency = data === null || data === void 0 ? void 0 : data.isAgency;
                    _this.handlePayment(isAgency);
                    break;
                case TypeAction.AdditionalNote:
                    _this.handleUpdateAdditionalNote(data);
                    break;
                case TypeAction.Rebook:
                    _this.props.store.reports.rebook(data).then(function (value) {
                        if (value.result === 'ok') {
                            // para que se actualice la tabla
                            if (_this.props.originList === typeList.Calendar) {
                                if (_this.props.onRebooked) {
                                    _this.props.onRebooked();
                                }
                            }
                            else if (_this.props.originList === typeList.Report) {
                                _this.props.store.reports.readGeneralSales(getData(typeList.Report));
                            }
                            _this.props.store.UI.newWarning('rebook correctamente');
                            _this.props.onToggle();
                            return value.result;
                        }
                        else {
                            _this.props.store.UI.newError(value.message);
                            return 'error';
                        }
                    }).then(function (value) {
                        var _a, _b, _c, _d;
                        if (value !== 'ok') {
                            return;
                        }
                        var ticket = _this.props.ticket;
                        var emailContact = (_a = ticket.contact.email) !== null && _a !== void 0 ? _a : '';
                        var emailBussines = (_b = ticket.businessEmails) !== null && _b !== void 0 ? _b : '';
                        var afiliateEmail = (_c = ticket.afiliateEmail) !== null && _c !== void 0 ? _c : '';
                        var ticketEmails = (_d = ticket.emails) !== null && _d !== void 0 ? _d : '';
                        var tempEmails = [];
                        if (emailContact) {
                            tempEmails.push(emailContact);
                        }
                        if (emailBussines) {
                            tempEmails.push(emailBussines);
                        }
                        if (afiliateEmail) {
                            tempEmails.push(afiliateEmail);
                        }
                        if (ticketEmails) {
                            tempEmails.push(ticketEmails);
                        }
                        tempEmails.push('reservas@ticando.net');
                        var emails = tempEmails.join(',');
                        var _data = {
                            numero: _this.props.ticket.numero,
                            clientName: _this.props.store.users.user.client,
                            language: _this.props.store.users.user.language,
                            emails: emails,
                            action: TypeAction.Rebook
                        };
                        _this.props.store.reports.sendEmail(_data);
                    }).catch(function (error) {
                        console.log('se ha producido un error: ', error);
                    });
                    break;
                case TypeAction.ChangeDatebook:
                    if (data.daterefund || data.refund_id) {
                        alert(T('canceledNoModified'));
                        return;
                    }
                    _this.setState({ hideModalDatePicker: false });
                    break;
                case TypeAction.Cancel:
                    _this.setState({ hideModalDatePicker: true });
                    break;
                default:
            }
            return;
        };
        _this.handlePayment = function (isAgency) {
            var store = _this.props.store;
            store.tempDuePaymentsStore.user = store.users.user;
            if (!isAgency) {
                store.tempDuePaymentsStore.send(_this.props.ticket)
                    .then(function (value) {
                    if (value.result === 'ok') {
                        store.UI.newWarning('Pago realizado correctamente');
                        store.dashboardTicket.calendarReport(Range.Month, typeList.Calendar);
                    }
                    else {
                        store.UI.newError(value.message);
                    }
                    _this.props.onToggle();
                })
                    .catch(function (error) { return store.UI.newError('Se ha producido un error, por favor contacte con el servido técnico, eroor 589'); });
                return;
            }
            /** es agencia */
            // si no tiene contact no permitimos
            if (!_this.props.ticket.contact) {
                return alert(T('noContact'));
            }
            store.tempDuePaymentsStore.terminal = 'Ticando Panel';
            store.tempDuePaymentsStore.sendPaymentOrder(_this.props.ticket, _this.props.store.users.user);
        };
        return _this;
    }
    TicketRenderModal.prototype.render = function () {
        var _this = this;
        var itemList = [];
        var item = this.props.ticket;
        // console.log('item: ', item)
        if (!item) {
            return null;
        }
        // item.image = `${process.env.REACT_APP_SERVER}${item.image}`
        itemList.push(item);
        if (this.props.ticket.ticketRefunded) {
            var temp = this.props.ticket.ticketRefunded;
            temp.image = item.image;
            itemList.push(temp);
        }
        var externalCloseBtn = React.createElement("button", { className: "close", style: { color: theme.color.primary, position: 'absolute', top: '50px', right: '15px', fontSize: 60, opacity: 1 }, onClick: this.props.onToggle }, "\u00D7");
        return (React.createElement("div", { className: "animated fadeIn " },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.props.onToggle, external: externalCloseBtn, style: { width: !itemList ? '320px' : "".concat(itemList.length * 320, "px"), minWidth: !itemList ? '320px' : "".concat(itemList.length * 300, "px") } },
                        React.createElement(ModalBody, { style: { padding: 0, opacity: 1 } },
                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row' } }, itemList.map(function (value, index) {
                                return (React.createElement(RenderTicket, { showPaymentMethod: value.totalDue > 0, key: index, ticket: value, onClick: function (action, data) {
                                        if (value.agency_id) {
                                            if (data !== undefined) {
                                                data.isAgency = !!value.agency_id;
                                            }
                                            else {
                                                data = {};
                                                data.isAgency = !!value.agency_id;
                                            }
                                        }
                                        _this.handleOnclick(action, data);
                                    }, onPay: _this.handleChangeInput, index: index, hideModalDatePicker: _this.state.hideModalDatePicker }));
                                // return RenderTicket(value, this.handleRefund,index)
                            }))))))));
    };
    TicketRenderModal = __decorate([
        inject('store'),
        observer
    ], TicketRenderModal);
    return TicketRenderModal;
}(Component));
// true si es para el mismo dia y mes y año
// false porque tiene time
export var fechasIguales = function (date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
};
var toTotalesNegativo = function (ticket) {
    ticket.lines.forEach(function (line) {
        line.taxBase = -1 * line.taxBase;
        line.taxAmount = -1 * line.taxAmount;
        line.total = -1 * line.total;
    }); // TODO cancelado total
    ticket.payments.forEach(function (payment) {
        payment.amount = -1 * payment.amount;
    }); // TODO cancelado total
    ticket.total = -1 * Number(ticket.total);
    ticket.taxAmount = -1 * Number(ticket.taxAmount);
    ticket.netAmount = -1 * Number(ticket.netAmount);
    return ticket;
};
export default TicketRenderModal;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketRenderModal.tsx
// module id = 124
// module chunks = 0